import { ReactComponent as LocationIcon } from '@/img/confirmation_page/location.svg';
import { ReactComponent as PeopleIcon } from '@/img/confirmation_page/people.svg';
import Stars from '@/components/general/Stars';
import _ from 'lodash';
import ImageUtils from '../../../utils/ImageUtils';
import { useTranslation } from 'react-i18next';

const ReservationDetails = ({ hotel, reservation }) => {
	const { t } = useTranslation();

	const { image: hotelImage, name: hotelName, stars, stars_hide, hasReview, address, city } = hotel;

	const reviews = _.get(hotel, 'review.votes');

	const rooms = _.get(reservation, 'deal.details.room_count');
	const guestsPerRoom = _.get(reservation, 'deal.guestsPerRoom');
	const childrenAges = _.get(reservation, 'deal.children_ages', []);

	const numberOfGuests = guestsPerRoom * rooms;
	const numberOfChildren = childrenAges.length * rooms;

	const roomsText = `${rooms} ${rooms === 1 ? t('Room') : t('Rooms')}`;
	const guestsText = `${numberOfGuests} ${numberOfGuests === 1 ? t('Adult') : t('Adults')}`;

	const formattedChildrenAges = childrenAges.map((age) => (age === 0 ? t('underOne') : age));

	const childrenText =
		numberOfChildren > 0
			? `${numberOfChildren} ${numberOfChildren === 1 ? t('Child') : t('Children')} (${numberOfChildren === 1 ? t('age') : t('ages')} ${formattedChildrenAges.join(', ')})`
			: null;

	return (
		<div className="reservation-details">
			<div className="reservation-details__image">
				<img src={hotelImage ?? ImageUtils.FALLBACK_IMAGE} />
			</div>
			<div className="reservation-details__hotel-name">{hotelName}</div>
			<div className="reservation-details__reviews">
				{stars && <Stars stars={stars} hide={stars_hide} />}
				{hasReview && (
					<span>
						{' '}
						| {reviews} {t('Reviews')}
					</span>
				)}
			</div>
			<div>
				<div className="reservation-details__address">
					<LocationIcon />
					{address}, {city}
				</div>
				<div className="reservation-details__rooms-and-guests">
					<PeopleIcon />
					{roomsText} | {guestsText} {childrenText && ` | ${childrenText}`}
				</div>
			</div>
		</div>
	);
};

export default ReservationDetails;
